import type { HistogramConfig } from '../histogram/histogram-chart.model';

export interface OgiveParams {
  readonly data: number[];
  readonly config: HistogramConfig;
}

export interface OgiveDisplayConfig {
  readonly lineColor?: string;
  readonly showDataPoints?: boolean;
  readonly xAxisLabel?: string;
  readonly yAxisLabel?: string;
}

export const DEFAULT_OGIVE_DISPLAY: OgiveDisplayConfig = {
  lineColor: '#6366f1',
  showDataPoints: true,
  xAxisLabel: 'Value',
};
